export const getCurrentTime = () => {};

export const getCurrentDateSeconds = () => {
  let date_timestamp = new Date();
  return Math.floor(date_timestamp.getTime() / 1000);
};

export const getCurrentWeekMinute = () => {
  const now = new Date();
  let dayIndex = now.getDay();
  const adjustedDay = dayIndex === 0 ? 6 : dayIndex - 1;

  const hours = now.getHours();
  const minutes = now.getMinutes();
  return adjustedDay * 1440 + hours * 60 + minutes;
};

export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const R = 6371; // Radio de la Tierra en km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const DAYS = [
  "Lunes",
  "Martes",
  "Miercoles",
  "Jueves",
  "Viernes",
  "Sabado",
  "Domingo",
];

const formatTime = (totalMinutes: number) => {
  const minsInWeek = 10080;
  const normalizedMins = totalMinutes % minsInWeek;

  const dayMinutes = normalizedMins % 1440;
  let hours = Math.floor(dayMinutes / 60);
  const mins = dayMinutes % 60;

  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours || 12;

  const strMins = mins < 10 ? "0" + mins : mins;

  return `${hours}:${strMins} ${ampm}`;
};

export const getHumanSchedule = (
  intervals: { start: number; end: number }[],
) => {
  if (!intervals || intervals.length === 0) return "Cerrado";

  const scheduleByDay: { [key: string]: string[] } = {};

  intervals.forEach((interval) => {
    const dayIdx = Math.floor(interval.start / 1440);
    const dayName = DAYS[dayIdx] || "Lunes";
    if (!scheduleByDay[dayName]) scheduleByDay[dayName] = [];
    const timeString = `${formatTime(interval.start)} - ${formatTime(
      interval.end,
    )}`;
    scheduleByDay[dayName].push(timeString);
  });
  return Object.entries(scheduleByDay)
    .map(([day, times]) => {
      return `${day} - (${times.join(" y ")})`;
    })
    .join("\n");
};

export const getCurrentMilitaryTime = () => {};
